// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.feature.FeatureFlagSummaryResponse */
/* istanbul ignore next */
@GandalfModel
export class FeatureFlagSummaryResponse extends GandalfModelBase {

	@GandalfConstantDecorator(constants.FeatureFlagAccess)
	@GandalfProperty({ designType: constants.FeatureFlagAccess })
	access!: constants.FeatureFlagAccess | null;

	@GandalfProperty({ designType: Boolean })
	active!: boolean | null;

	@GandalfProperty({ designType: String })
	applicationKey!: string | null;

	@GandalfProperty({ designType: String })
	documentationLink!: string | null;

	@GandalfProperty({ designType: Number })
	id!: number | null;

	@GandalfProperty({ designType: String })
	internalName!: string | null;

}
